import { useContext, useState } from 'react';
import {
  Avatar,
  Box,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Switch,
  Tooltip,
  Typography,
} from '@mui/material';
import { AccountCircle, MoreVert } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useUser } from '../../../components/Auth/User';
import { ColorModeContext } from '../../context/ColorMode';

const NombreUsuarioDividido = ({ texto }) => {
  // Usamos regex para capturar la parte antes y dentro de los paréntesis
  const match = texto.match(/^(.*?)\s*(\([^)]*\))?$/);

  const partePrincipal = match?.[1]?.trim() || '';
  const parteEntreParentesis = match?.[2] || '';

  return (
    <div>
      <div>{partePrincipal}</div>
      {parteEntreParentesis && <div>{parteEntreParentesis}</div>}
    </div>
  );
};

const RenderTopList = ({ list, onClose }) => {
  return list.map((item) => {
    return (
      <MenuItem
        key={item.key}
        component={Link}
        to={item.to}
        onClick={(e) => {
          if (onClose) onClose(e);
        }}
      >
        <ListItemIcon>{item.icon()}</ListItemIcon>
        {item.label}
      </MenuItem>
    );
  });
};

export const TopMenu = ({ list = [] }) => {
  const { user } = useUser();
  const { mode, toggleColorMode } = useContext(ColorModeContext);
  const isDarkMode = mode === 'dark';
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <Tooltip title='Menú de usuario.'>
          <IconButton
            onClick={handleClick}
            size='small'
            sx={{ ml: 2 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup='true'
            aria-expanded={open ? 'true' : undefined}
            color='inherit'
          >
            <AccountCircle sx={{ display: { xs: 'none', md: 'flex' } }} />
            <MoreVert sx={{ display: { xs: 'flex', md: 'none' } }} />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        disableScrollLock
        anchorEl={anchorEl}
        id='account-menu'
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                // mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <Grid
          aria-label='Usuario actual:'
          aria-haspopup='true'
          container
          flexDirection={'column'}
          flexWrap={'wrap'}
          alignItems={'center'}
          sx={{
            outline: 0,
            minHeight: 'auto',
            margin: 0,
            marginBottom: '16px',
            padding: 0,
            maxWidth: '100%',
          }}
        >
          <Grid item sx={{ padding: '6px 16px' }}>
            <Avatar sx={{ width: 50, height: 50 }} />
          </Grid>
          <Grid item sx={{ padding: '6px 16px' }}>
            <Typography variant='inherit' noWrap textAlign={'center'}>
              <NombreUsuarioDividido texto={user?.razonsocial || 'Cuenta'} />
            </Typography>
          </Grid>
        </Grid>
        <Divider />
        <RenderTopList list={list} onClose={handleClose} />
        <Grid
          container
          flexDirection={'column'}
          flexWrap={'wrap'}
          alignItems={'center'}
          sx={{
            outline: 0,
            minHeight: 'auto',
            margin: 0,
            marginBottom: '16px',
            padding: 0,
            maxWidth: '100%',
            display: { xs: 'initial', md: 'none' },
          }}
        >
          <Divider />
          <Grid item sx={{ padding: '6px 16px' }}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    checked={!!isDarkMode}
                    onChange={() => toggleColorMode()}
                    inputProps={{ 'aria-label': 'controlled' }}
                    color='secondary'
                  />
                }
                label='Tema oscuro'
              />
            </FormGroup>
          </Grid>
        </Grid>
      </Menu>
    </>
  );
};
